import { render, staticRenderFns } from "./CookieManagement.vue?vue&type=template&id=352c3cb6"
import script from "./CookieManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieManagement.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports